import {
  GET_CURRENT_PERSON_ALL_STATUS_REQUEST,
  GET_CURRENT_PERSON_ALL_STATUS_SUCCESS,
  GET_CURRENT_PERSON_ALL_STATUS_FAILURE,
  GET_DAY_BEFORE_COUNT_BY_STATUS_REQUEST,
  GET_DAY_BEFORE_COUNT_BY_STATUS_SUCCESS,
  GET_DAY_BEFORE_COUNT_BY_STATUS_FAILURE,
  GET_CURRENT_PERSON_STATUS_REQUEST,
  GET_CURRENT_PERSON_STATUS_SUCCESS,
  GET_CURRENT_PERSON_STATUS_FAILURE,
  GET_PERSON_LEAD_NOTE_STATUS_REQUEST,
  GET_PERSON_LEAD_NOTE_STATUS_SUCCESS,
  GET_PERSON_LEAD_NOTE_STATUS_FAILURE,
  GET_PERSON_QR_CODE_STATUS_REQUEST,
  GET_PERSON_QR_CODE_STATUS_SUCCESS,
  GET_PERSON_QR_CODE_STATUS_FAILURE,
} from '../../constants/ActionTypes'

const initialState = {
  // 複数ステータスの場合
  isLoadingCurrentPersonStatuses: {},
  currentStatusLists: {},
  pageInfoCurrentPersonStatuses: {},
  // ステータス別の前日比の場合
  isLoadingDayBeforeCountByStatuses: {},
  pageInfoDayBeforeCountByStatuses: {},
  // 単一ステータスの場合
  isLoadingCurrentPersonStatus: false,
  currentStatusList: [],
  pageInfoCurrentPersonStatus: {},
}

export default (state = initialState, action) => {
  state = {
    ...state,
    shortMessage: '',
    successMessage: '',
    errorMessage: '',
  }

  switch (action.type) {
    case GET_CURRENT_PERSON_ALL_STATUS_REQUEST:
      return {
        ...state,
        isLoadingCurrentPersonStatuses: { ...state.isLoadingCurrentPersonStatuses, [action.payload.type]: true },
        currentStatusLists: { ...state.currentStatusLists, [action.payload.type]: null },
        pageInfoCurrentPersonStatuses: { ...state.pageInfoCurrentPersonStatuses, [action.payload.type]: null }
      }
    case GET_CURRENT_PERSON_ALL_STATUS_SUCCESS:
      return {
        ...state,
        isLoadingCurrentPersonStatuses: { ...state.isLoadingCurrentPersonStatuses, [action.payload.type]: false },
        currentStatusLists: { ...state.currentStatusLists, [action.payload.type]: action.payload.data },
        pageInfoCurrentPersonStatuses: { ...state.pageInfoCurrentPersonStatuses, [action.payload.type]: action.payload.pageInfo },
      }
    case GET_CURRENT_PERSON_ALL_STATUS_FAILURE:
      return {
        ...state,
        isLoadingCurrentPersonStatuses: { ...state.isLoadingCurrentPersonStatuses, [action.payload.type]: false },
      }

    case GET_DAY_BEFORE_COUNT_BY_STATUS_REQUEST:
      return {
        ...state,
        isLoadingDayBeforeCountByStatuses: { ...state.isLoadingDayBeforeCountByStatuses, [action.payload.type]: true },
        pageInfoDayBeforeCountByStatuses: { ...state.pageInfoDayBeforeCountByStatuses, [action.payload.type]: null }
      }
    case GET_DAY_BEFORE_COUNT_BY_STATUS_SUCCESS:
      return {
        ...state,
        isLoadingDayBeforeCountByStatuses: { ...state.isLoadingDayBeforeCountByStatuses, [action.payload.type]: false },
        pageInfoDayBeforeCountByStatuses: { ...state.pageInfoDayBeforeCountByStatuses, [action.payload.type]: action.payload.pageInfo },
      }
    case GET_DAY_BEFORE_COUNT_BY_STATUS_FAILURE:
      return {
        ...state,
        pageInfoDayBeforeCountByStatuses: { ...state.pageInfoDayBeforeCountByStatuses, [action.payload.type]: false },
      }

    case GET_CURRENT_PERSON_STATUS_REQUEST:
      return {
        ...state,
        isLoadingCurrentPersonStatus: true,
        currentStatusList: [],
        pageInfoCurrentPersonStatus: {},
      }
    case GET_CURRENT_PERSON_STATUS_SUCCESS:
      return {
        ...state,
        isLoadingCurrentPersonStatus: false,
        currentStatusList: action.payload.data,
        pageInfoCurrentPersonStatus: action.payload.pageInfo,
      }
    case GET_CURRENT_PERSON_STATUS_FAILURE:
      return {
        ...state,
        isLoadingCurrentPersonStatus: false,
      }

    case GET_PERSON_LEAD_NOTE_STATUS_REQUEST:
      return {
        ...state,
        leadNoteList: [],
        isLoadingLeadNote: true,
        pageInfoLeadNote: {},
      }
    case GET_PERSON_LEAD_NOTE_STATUS_SUCCESS:
      return {
        ...state,
        leadNoteList: action.payload.data,
        isLoadingLeadNote: false,
        pageInfoLeadNote: action.payload.pageInfo,
      }
    case GET_PERSON_LEAD_NOTE_STATUS_FAILURE:
      return {
        ...state,
        isLoadingLeadNote: false,
      }

    case GET_PERSON_QR_CODE_STATUS_REQUEST:
      return {
        ...state,
        qrCodeList: [],
        isLoadingQrCode: true,
        pageInfoQrCode: {},
      }
    case GET_PERSON_QR_CODE_STATUS_SUCCESS:
      return {
        ...state,
        qrCodeList: action.payload.data,
        isLoadingQrCode: false,
        pageInfoQrCode: action.payload.pageInfo,
      }
    case GET_PERSON_QR_CODE_STATUS_FAILURE:
      return {
        ...state,
        isLoadingQrCode: false,
      }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/currentPersonStatus.js